import { useQuery } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';

import { LocaleResponse } from 'api/api';

import { globalConfig } from '~src/context/config';
import { useGlobalState } from '~src/global-state';

export function countryNamesLocalizationGet(locale: string) {
  return axios.get<Required<LocaleResponse>>(
    `${globalConfig.cdnUrl}/country-names-locales/${locale}.json`,
    {
      transformResponse: [
        // imitate LocaleResponse
        data => ({ locale, translations: JSON.parse(data) }),
      ],
    }
  );
}

export function useCountryNamesLocalizationQuery() {
  const globalState = useGlobalState();

  return useQuery<Required<LocaleResponse>, AxiosError>({
    queryKey: ['country-names'],
    queryFn: async () => {
      const { data } = await countryNamesLocalizationGet(globalState.locale);
      return data;
    },
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
}

export function useCountryNamesTranslations() {
  const { data: countryNamesLocalization } = useCountryNamesLocalizationQuery();

  function translate(country: string) {
    if (!countryNamesLocalization) {
      return '';
    }

    return countryNamesLocalization.translations[`country.${country}`];
  }

  return { translate };
}
